import { useState, useCallback } from 'react';

export const useTabIndex = (initialTabIndex) => {
  const [tabIndex, setTabIndex] = useState(initialTabIndex);

  const handleSelectTabIndex = useCallback((nextTabIndex) => {
    setTabIndex(nextTabIndex);
  }, []);

  const handleNextTabIndex = useCallback(() => {
    setTabIndex((prevTabIndex) => prevTabIndex + 1);
  }, []);

  const handlePreviousTabIndex = useCallback(() => {
    setTabIndex((prevTabIndex) => prevTabIndex - 1);
  }, []);

  const resetTabIndex = useCallback(() => {
    setTabIndex(initialTabIndex);
  }, [initialTabIndex]);

  return {
    tabIndex,
    handleSelectTabIndex,
    handleNextTabIndex,
    handlePreviousTabIndex,
    resetTabIndex,
  };
};
